module.exports = __webpack_public_path__ + "static/media/ArrowRightIcon.5e099241.svg";